/**
 * A AJUDA DE CADA TELA (§11-F).
 *
 * POR QUE ISTO EXISTE
 *
 * A Central de Ajuda tinha trinta e seis artigos, e quem estava perdido numa
 * tela precisava sair dela, abrir a Central, escolher a categoria certa e
 * adivinhar o título. É trabalho demais para alguém que já não sabe o que a tela
 * faz — e o resultado prático era ninguém ler nada.
 *
 * Este mapa liga ROTA a ARTIGO. Com ele, o cabeçalho de cada página oferece
 * "Como esta tela funciona" e o link vai direto para o texto certo.
 *
 * A regra que o teste cobra: todo item do menu operacional tem entrada aqui, e
 * toda entrada aponta para um artigo que existe. Item de menu novo sem artigo
 * reprova — porque a tela sem explicação é exatamente o que a navegação em
 * produção encontrou onze vezes.
 */

export const ARTIGO_DA_ROTA: Record<string, string> = {
  '/': 'primeiro-dia',
  // CERES-UX-001: as jornadas novas herdam o artigo do trabalho que reúnem.
  '/negocios': 'pipeline',
  '/relacionamentos': 'empresas',
  '/conversas': 'cadencias-e-caixa-de-entrada',
  '/mais': 'primeiro-dia',
  '/empresas': 'empresas',
  '/contatos': 'contatos',
  // CERES-022: `/leads` saiu do menu (redireciona para a Carteira), e o artigo
  // do módulo anterior continua na Central para quem chegar por busca.
  '/pre-vendas': 'pre-vendas',
  '/oportunidades': 'oportunidades',
  '/pipeline': 'pipeline',
  '/atividades': 'atividades',
  '/caixa-de-entrada': 'cadencias-e-caixa-de-entrada',
  '/cadencias': 'cadencias-e-caixa-de-entrada',
  '/catalogo': 'catalogo-comercial',
  '/comissoes': 'comissao',
  // CERES-DESAC-003: o artigo da Inteligência de Mercado saiu; o ICP
  // operacional é explicado em "Leads e prospecção".
  '/icp': 'leads-e-prospeccao',
  '/admin/importacao': 'primeiro-dia',
  // CERES-028: as áreas do Catálogo unificado herdam o artigo do Catálogo; os
  // endereços antigos do Playbook continuam mapeados porque a Central de Ajuda
  // é alcançada por busca, e quem procura "playbook" precisa chegar a algum
  // lugar que explique para onde ele foi.
  '/catalogo-comercial': 'catalogo-comercial',
  '/playbook': 'playbooks',
  '/playbooks': 'playbooks',
  '/propostas': 'propostas-e-contratos',
  // CERES-039: a geração assistida usa o mesmo artigo — para quem procura
  // ajuda, ela é a tela de Propostas, e não um módulo à parte.
  '/propostas/gerar': 'propostas-e-contratos',
  '/contratos': 'propostas-e-contratos',
  '/aprovacoes': 'aprovacoes',
  '/reunioes': 'reunioes',
  '/customer-success': 'pos-venda',
  '/receita': 'receita-e-forecast',
  '/relatorios': 'relatorios',
  '/agentes': 'assistente',
  '/assistente': 'assistente',
  '/parceiros': 'parceiros',
  '/reservas': 'reservas-de-conta',
  '/preferencias': 'idioma-e-fuso',
  '/meu-perfil': 'segundo-fator',
};

/**
 * O artigo da rota atual.
 *
 * Casa pelo caminho mais específico: `/empresas/123` recebe o artigo de
 * `/empresas`, e não o do painel. Sem isso, a ficha de uma empresa ofereceria a
 * ajuda errada — que é pior do que não oferecer nenhuma, porque quem clica sai
 * do lugar e não encontra o que procurava.
 */
export function artigoDaRota(caminho: string): string | null {
  const candidatos = Object.keys(ARTIGO_DA_ROTA)
    .filter((rota) => (rota === '/' ? caminho === '/' : caminho.startsWith(rota)))
    .sort((a, b) => b.length - a.length);
  return candidatos.length === 0 ? null : ARTIGO_DA_ROTA[candidatos[0]!]!;
}
